import { render } from "./TableShowForDiy.vue?vue&type=template&id=51d75013&scoped=true"
import script from "./TableShowForDiy.vue?vue&type=script&lang=js"
export * from "./TableShowForDiy.vue?vue&type=script&lang=js"

import "./TableShowForDiy.vue?vue&type=style&index=0&id=51d75013&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d75013"]])

export default __exports__